import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { webSentryOptions } from './lib/sentryConfig.ts';
import './index.css';
// CFG.I18N.A1: i18next must be initialised before any component that
// calls useTranslation() renders. Importing for side effects only — the
// module's top-level i18n.init() runs synchronously and registers the
// English bundle on the singleton.
import './i18n.ts';

// #3248 PR 2 — webSentryOptions adds beforeSend / beforeSendTransaction /
// beforeBreadcrumb scrubbers: Sentry starts before /action strips the
// #t=<token> fragment, so the token must be filtered out of what it records.
Sentry.init({
  ...webSentryOptions({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    mode: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA,
  }),
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});

function ErrorFallback() {
  return (
    <div style={{ padding: 40, textAlign: 'center', color: 'var(--text)' }}>
      <h1>Something went wrong</h1>
      <p>An unexpected error occurred. Please refresh the page.</p>
      <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>
        Refresh
      </button>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
